import styled from 'styled-components';
import { space, color, textAlign, alignSelf } from 'styled-system';
import { ThemeInterface } from '../theme/ThemeInterface';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { theme } from '../theme';

const Label = styled.label<StyledSystemProps>`
  ${space};
  ${color};
  ${textAlign};
  ${alignSelf};
  font-size: ${(props: ThemeInterface) => props.theme.fontSizes[0]};
  font-family: ${(props: ThemeInterface) => props.theme.fontFamily};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
`;

export default Label;

Label.defaultProps = {
  mb: 2,
  color: theme.colors.charcoalGrey,
};



// WEBPACK FOOTER //
// ./src/typography/Label.ts